import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"

import kebabCase from "@treefort/lib/kebab-case"
import icons from "@treefort/tokens/app/icons"

import { useActiveProfileId } from "../hooks/use-active-profile-id"
import { audioPlayer, Event } from "../lib/audio-player"
import { PlayableContent } from "../lib/consumable-content"
import { playContentAudio } from "../lib/content-audio"
import AsyncIconButton from "./async-icon-button"

export function ListenIconButton({
  id,
  consumableContent,
}: {
  id?: string
  consumableContent: PlayableContent | undefined
}) {
  const { t } = useTranslation()
  const profileId = useActiveProfileId()

  const listen = useCallback(() => {
    if (consumableContent) {
      // Resolve this function either when audio is loaded or when the player
      // signals that it will stop. This ensures that, if the video player takes
      // over and cancels the audio player while it's in the middle of loading,
      // the listen button doesn't hang in a loading state.
      return Promise.race([
        playContentAudio({ consumableContent, profileId }),
        audioPlayer.once(Event.WillStop),
      ])
    }
  }, [consumableContent, profileId])

  return (
    <AsyncIconButton
      id={kebabCase(
        id ||
          `listen-${`${consumableContent?.content.id}-${consumableContent?.content?.title}`}`,
      )}
      source={icons.headphones}
      color="secondary"
      onPress={listen}
      label={t("Listen")}
      minSize="buttonHeight"
    />
  )
}
